import { render, staticRenderFns } from "./InputsOutputsComponent.vue?vue&type=template&id=47d33308&scoped=true&"
import script from "./InputsOutputsComponent.vue?vue&type=script&lang=js&"
export * from "./InputsOutputsComponent.vue?vue&type=script&lang=js&"
import style0 from "./InputsOutputsComponent.vue?vue&type=style&index=0&id=47d33308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d33308",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
